import React, { useState } from "react";
import {
  Main, Timeline, Expertise, Project, Blog,
  Navigation, Footer, Certifications, Contact, CMDB,
} from "./components";
import FadeIn from "./components/FadeIn";
import "./index.scss";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ArticlePage from "./components/ArticlePage";
import ScrollToTop from "./components/ScrollToTop";
import NotFound from "./components/NotFound";
import TerraformPage from "./pages/TerraformPage";
import ArgoCDPage from "./pages/ArgoCDPage";
import DevOpsPage from "./pages/DevOpsPage";
import MonitoringPage from "./pages/MonitoringPage";
import AISecurityPage from "./pages/AISecurityPage";
import BackupPage from "./pages/BackupPage";

function App() {
  const [mode, setMode] = useState<string>("dark");

  const handleModeChange = () => {
    setMode((prev) => (prev === "dark" ? "light" : "dark"));
  };

  return (
    <Router>
      <div className={`main-container ${mode === "dark" ? "dark-mode" : "light-mode"}`}>
        <Navigation parentToChild={{ mode }} modeChange={handleModeChange} />
        <ScrollToTop />
        <FadeIn transitionDuration={700}>
          <Routes>
            <Route path="/" element={<Main />} />
            <Route path="/expertise" element={<Expertise />} />
            <Route path="/timeline" element={<Timeline />} />
            <Route path="/projects" element={<Project />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<ArticlePage />} />
            <Route path="/terraform-article" element={<TerraformPage />} />
            <Route path="/argocd-article" element={<ArgoCDPage />} />
            <Route path="/blog/devops-devsecops" element={<DevOpsPage />} />
            <Route path="/blog/monitoring" element={<MonitoringPage />} />
            <Route path="/blog/ai-security" element={<AISecurityPage />} />
            <Route path="/blog/backup-pra-prs" element={<BackupPage />} />
            <Route path="/cmdb" element={<CMDB />} />
            <Route path="/certifications" element={<Certifications />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </FadeIn>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
